import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { IStore } from 'store/store.props';

export const useTypedSelector: TypedUseSelectorHook<IStore> = useSelector;
